var styles = {"box":"LinkCollection_box_1xv1a_1","expand":"LinkCollection_expand_1xv1a_1","list":"LinkCollection_list_1xv1a_4","lines":"LinkCollection_lines_1xv1a_10","link":"LinkCollection_link_1xv1a_16","show":"LinkCollection_show_1xv1a_22"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
